import React from "react";
import { getClassName } from "@sscs/utils";
import styles from "./checkLabel.module.scss";
const CheckLabel = React.forwardRef(({ className, status, scanLevel = 0, isLevelCustomized = false, isReproducibilityCheck = false, isDiffCheck = false, ...props }, ref) => {
    const classes = getClassName(styles.root, styles[status !== null && status !== void 0 ? status : "none"], className);
    if (!status) {
        return (React.createElement("div", { ...props, ref: ref, className: classes }, "none"));
    }
    if (isReproducibilityCheck) {
        return (React.createElement("div", { ...props, ref: ref, className: classes },
            "RB:",
            status));
    }
    if (isDiffCheck) {
        return (React.createElement("div", { ...props, ref: ref, className: classes },
            "DF:",
            status));
    }
    if (!scanLevel) {
        return (React.createElement("div", { ...props, ref: ref, className: classes },
            "CI:",
            status));
    }
    return (React.createElement("div", { ...props, ref: ref, className: classes },
        isLevelCustomized ? "C" : "L",
        scanLevel,
        ":",
        status));
});
CheckLabel.displayName = "CheckLabel";
export default CheckLabel;
//# sourceMappingURL=CheckLabel.js.map